import {Component, Injector, ViewChild} from "@angular/core";
import {LoginService} from "../../../core/services/login.service";
import {AuthResponseTO} from "../../../core/classes/auth.response.to";
import {VersionService} from "../../../core/services/version.service";
import {Usuario} from "../../../../classes/usuario";
import {BaseComponent} from "../../../ui/components/base/base.component";
import {forkJoin} from "rxjs";
import {UsuarioService} from "../../../commons/services/usuario.service";
import {UsuarioFilter} from "../../../commons/filters/usuario.filter";
import {LoginFilter} from "../../../core/filters/login.filter";
import {ReCaptchaComponent} from "../../../ui/components/captcha/re.captcha.component";
import {AlertService} from "../../../ui/services/alert.service";
import {AuthService} from "../../../core/services/auth.service";

@Component({
  selector: 'landing-page',
  templateUrl: './landing.page.component.html',
  styleUrls: ['./landing.page.component.scss']
})
export class LandingPageComponent extends BaseComponent {

  @ViewChild("reCaptchaComponent")
  reCaptchaComponent: ReCaptchaComponent;

  constructor(private injector: Injector,
              private authService: AuthService,
              private loginService: LoginService,
              private usuarioService: UsuarioService,
              private versionService: VersionService,
              private alertService: AlertService) {
    super(injector);
  }

  confirmaLogin: string;

  login: string;

  loginErrors: string[];

  loginIndicator: boolean = false;

  novoLogin: string;

  novaSenha: string;

  novaSenhaConfirmacao: string;

  nroDocumento: string;

  popupUsuario: boolean = false;

  senha: string;

  senhaInvalida : boolean = false;

  trocarSenha: boolean = false;

  usuario: Usuario = new Usuario();

  userSession: string;

  usuarioInvalido : boolean = false;

  usuarioNaoAtivoError: boolean = false;

  versao: string = "";

  reCaptcha: string;

  ngOnInit(): void {
    if(window.location.href =='https://nfe-cidades.com.br/landing-page'){
      window.location.href ='https://www.nfe-cidades.com.br/landing-page';
    }else{
      this.carrega()
    }
  }

  acionaRedefinir() {
    this.clearErrorMessages();
    if (this.usuarioInvalido) {
      if (!this.novoLogin || !this.confirmaLogin) {
        this.addErrorMessage("Os campos usuário e confirmação devem ser preenchidos.");
      } else if (this.novoLogin == this.confirmaLogin) {
        let reg = /[^LM\S{NP}]/g;

        if (reg.test(this.novoLogin)) {
          this.addErrorMessage("Os campos usuário e confirmação não devem possuir nenhum espaço.");
        }
      } else {
        this.addErrorMessage("Os campos usuário e confirmação estão diferentes.");
      }
    }

    if(this.senhaInvalida){
      if (!this.novaSenha || !this.novaSenhaConfirmacao) {
        this.addErrorMessage("Os campos senha e confirmação de senha devem ser preenchidos.");
      } else if (this.novaSenha == this.novaSenhaConfirmacao) {

        if (this.novaSenha.length < 6) {
          this.addErrorMessage("Os campos senha e confirmação de senha devem possuir no minímo 6 caractéres");
        }
      } else {
        this.addErrorMessage("Os campos senha e confirmação de senha são diferentes");
      }
    }

    if(!this.hasErrorMessages()){
      this.atualizar();
    }
  }

  atualizar() {
    let loginFilter: LoginFilter = new LoginFilter();

    loginFilter.novoUsuario = this.novoLogin;
    loginFilter.usuario = this.login;
    loginFilter.senha = this.senha;
    loginFilter.novaSenha = this.novaSenha;

    return this.of(this.loginService.atualizar(loginFilter), usuario => {
      this.login = usuario.usuario;
      this.senha = this.novaSenha;

      this.popupUsuario = false;
    });
  }

  buscarAuthResponse() {
    let usuarioFilter: UsuarioFilter = new UsuarioFilter();

    usuarioFilter.usuario = this.login;
    usuarioFilter.senha = this.senha;
    this.usuarioService.buscarAuthResponsePorUsuario(usuarioFilter).subscribe(resp => {
      this.loginIndicator = false;
      if (!resp.success) {
        this.handleLoginError(resp);

        return;
      }

      if(resp.relogar){
        this.alertService.show("Senha do usuário expirou, logue com a nova senha.").then(() =>{
          this.senha = "";
          this.authService.signOut();
        });
        return;
      }

      this.navigate('/home');
    }, error => {
      this.loginIndicator = false;
      this.authService.removeAllCookie();

      this.loginErrors.push("Falha ao processar requisição");
    });
  }

  buscarDocumento() {
    let loginFilter: LoginFilter = new LoginFilter();
    loginFilter.captcha = this.reCaptcha;
    loginFilter.senha = this.nroDocumento;
    return this.of(this.loginService.buscarDocumento(loginFilter), response =>{
      if (this.nroDocumento && this.nroDocumento.trim()) {
        this.navigate(response.url,null, null, {senha: this.nroDocumento, data: this.replacePlusFromString(response.validador)});
      }
    }, error =>{
      this.handleError(error);
      this.alertService.showError(this.errorMessages.map(s => s));
    });

  }

  carrega() {
    return this.of(forkJoin(this.authService.currentAuthenticatedUser(), this.versionService.buscar()), data => {
      if (data[0]) {
        this.navigate('/home/inicial-menu');
      }else{
        this.authService.signOut();
      }
      this.versao = data[1];
      if(this.reCaptchaComponent){
        this.reCaptchaComponent.init();
      }
    })
  }

  handleLoginError(resp: AuthResponseTO) {
    this.authService.signOut();

    if (!resp.errors || resp.errors.length == 0) {
      this.loginErrors.push('Falha ao processar login');
      return;
    }

    resp.errors.forEach(errorObj => {
      if (errorObj.type == 'info') {
        this.loginErrors.push(errorObj.info);
      } else if (errorObj.type == 'loginFailed') {
        if (errorObj.info == 'usuarioNaoAtivoFiscal') {
          this.loginErrors.push('Apenas usuários ativados são permitidos!');
        } else if (errorObj.info == 'usuarioNaoAtivo') {
          this.loginErrors.push('Apenas usuários ativados são permitidos!');
        } else if (errorObj.info == 'loginInvalido') {
          this.loginErrors.push('Usuário ou senha inválido.');
        } else if (errorObj.info == 'municipioBloqueado') {
          this.loginErrors.push('Este sistema está indisponível a pedido da Prefeitura.');
        } else if (errorObj.info == 'municipioBloqueadoNaoPagamento') {
          this.loginErrors.push('Este sistema ficou indisponível. Favor contatar o suporte técnico da Prefeitura Municipal.');
        } else if (errorObj.info == 'empresaBloqueada') {
          this.loginErrors.push('O acesso dessa empresa foi bloqueado.');
        } else if (errorObj.info == 'custom') {
          this.loginErrors.push('Não foi possível realizar o login.');
        } else if (errorObj.info == 'usuarioNaoAtivoFiscal') {
          this.loginErrors.push('Aguarde a aprovação do fiscal.');
        } else if (errorObj.info == 'empresaBloqueada') {
          this.loginErrors.push(errorObj.info);
        } else if (errorObj.info == 'usuarioNaoAtivo') {
          this.usuarioNaoAtivoError = true;
        }
      }
    });
  }

  onLogin() {
    this.loginIndicator = true;
    this.usuarioInvalido = false;
    this.senhaInvalida = false;

    this.loginErrors = [];
    this.usuarioNaoAtivoError = false;

    if (!this.login || !this.senha) {
      this.loginIndicator = false;

      this.loginErrors.push("O campo usuário e a senha são obrigatórios.");

      return;
    }

    let reg = /[^LM\S{NP}]/g;

    if (reg.test(this.login) || this.senha.length < 6) {
      let loginFilter: LoginFilter = new LoginFilter();

      loginFilter.senha = this.senha;
      loginFilter.usuario = this.login;

      this.loginService.buscar(loginFilter).subscribe(usuario => {
        this.loginIndicator = false;

        if (usuario) {
          //Se tirar não funciona o teste.
          reg = /[^LM\S{NP}]/g;
          if(reg.test(usuario.usuario)){
            this.usuarioInvalido = true;
          }

          if(this.senha.length < 6){
            this.senhaInvalida = true;
          }
          this.usuario = usuario;
          this.novoLogin = "";
          this.confirmaLogin= "";
          this.novaSenha = "";
          this.novaSenhaConfirmacao = "";

          this.popupUsuario = true;
        } else {
          this.loginErrors.push("Campo(s) usuário e/ou senha inválido(s).");

        }
        return;
      });
    } else {
      if (this.trocarSenha) {
        if (this.novaSenha && this.novaSenhaConfirmacao) {
          if (this.novaSenha.length < 6) {
            this.loginIndicator = false;

            this.loginErrors.push("O campo nova senha deve possuir pelo menos seis caracteres.");

            return;
          }

          if (this.novaSenha != this.novaSenhaConfirmacao) {
            this.loginIndicator = false;

            this.loginErrors.push("O campo nova senha e sua confirmação deve ser iguais.");

            this.novaSenha = "";
            this.novaSenhaConfirmacao = "";

            return;
          }

          let usuarioFilter: UsuarioFilter = new UsuarioFilter();
          usuarioFilter.usuario = this.userSession;
          usuarioFilter.senha = this.novaSenha;

          this.usuarioService.completeNewPassword(usuarioFilter).subscribe(() => {
            this.trocarSenha = false;

            this.navigate('/home');
          }, err => {
            this.loginIndicator = false;

            console.log(err);
            this.loginErrors.push(err);

            return;
          })
        } else {
          this.loginErrors.push("O campo nova senha e sua confirmação são obrigatórios.");

          return;
        }
      } else {
        this.signIn();
      }
    }
  }

  signIn() {
    this.authService.signIn(this.login, this.senha).subscribe(resp => {
      if (resp && resp.forceNewPassword) {
        this.loginIndicator = false;

        this.userSession = resp.usuario;
        this.trocarSenha = true;

        return;
      }
      this.authService.user.subscribe(u => {
        if (u && u.access_token) {
          this.authService.updateAllCookie(`Bearer ${u.access_token}`)
        }
      });

      this.buscarAuthResponse();
    }, err => {
      this.loginIndicator = false;

      if (err.className.includes('UnauthorizedException')){
        this.loginErrors.push("Usuário ou senha inválido.");
      }else if(err.className.includes('BlockedUserException')){
        this.loginErrors.push("Usuário bloqueado.");
      }else if(err.className.includes('BlockedMunicipioException')){
        this.loginErrors.push("Este sistema está indisponível a pedido da Prefeitura.")
      }
      else {
        console.log(err);
        this.loginErrors.push("Falha ao processar requisição.");
      }
    });
  }
}
